var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Just a tinkering area for my code.")]),_vm._l((_vm.codeBlocks),function(block){return _c('div',[_c('header',{staticClass:"t1"},[_vm._v(_vm._s(block.title))]),_c('pre',[_vm._v(_vm._s(block.body))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }